module.exports = __webpack_public_path__ + "static/media/global.862c4fdd.svg";